import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
    AnyApiFactory, ApiRef, BackstageIdentityApi,
    configApiRef,
    createApiFactory, createApiRef, discoveryApiRef, oauthRequestApiRef, ProfileInfoApi, SessionApi,
} from '@backstage/core-plugin-api';

import { catalogApiRef, entityPresentationApiRef } from '@backstage/plugin-catalog-react';
import { SimpleIconsEntityPresentationApi } from '@dweber019/backstage-plugin-simple-icons';
import {OAuth2} from "@backstage/core-app-api";

//apis
export const cloudidpOIDCAuthApiRef: ApiRef<ProfileInfoApi & BackstageIdentityApi & SessionApi> = createApiRef({
  id: 'cloudidp',
});

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: cloudidpOIDCAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
        OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: 'cloudidp',
            title: 'Cloud IDP auth provider',
            icon: () => null,
          },
          environment: configApi.getOptionalString('auth.environment'),
          defaultScopes: ['openid', 'profile', 'email'],
        }),
  }),
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: entityPresentationApiRef,
    deps: { catalogApi: catalogApiRef },
    factory: ({ catalogApi }) => {
      return SimpleIconsEntityPresentationApi.create({ catalogApi });
    },
  }),
];
